import { AppAction } from "../root/AppAction";
import UserEvents from "./UserEvents";
import { User, UserData, UserList } from "./User";

export interface UserStore {
    isLoading: boolean;
    user?: UserData;
    userInfo?: User;
    userInfoList?: UserList[];
    skillList: string[];
    isUpdateUserInfo: boolean;
    isSuccessUpdateUserInfo: boolean;
    isFailedUpdateUserInfo: boolean;
    isSuccessUpdateUserProfileImage: boolean;
    isFailedUpdateUserProfileImage: boolean;
    isAuthenticating: boolean;
    errorMessage: string;
    email?: string;
    // updateUserList?: UpdateUserList[];
}

const initialStore: UserStore = {
    isAuthenticating: false,
    isLoading: false,
    skillList: [],
    isUpdateUserInfo: false,
    isSuccessUpdateUserInfo: false,
    isFailedUpdateUserInfo: false,
    isSuccessUpdateUserProfileImage: false,
    isFailedUpdateUserProfileImage: false,
    errorMessage: ""
};

// ログインユーザーのサムネイル更新（ユーザーリスト更新時）
function refreshLoginUserImage(userList: UserList[], userInfo: User | undefined) {
    if (!userInfo) return ""
    for (let index = 0; index < userList.length; index++) {
        const element = userList[index];
        if (element.id === String(userInfo.id)) {
            return element.imageUrl
        }
    }
}

export default function user(state: UserStore = initialStore, action: AppAction) {
    switch (action.type) {
        case UserEvents.AuthnStart:
            return {
                ...state,
                isAuthenticating: true
            };
        case UserEvents.AuthnComplete:
            return {
                ...state,
                isAuthenticating: false,
                userInfo: action.user
            };
        case UserEvents.GetUserInfoListStarted:
            return {
                ...state,
                isLoading: true
            };

        case UserEvents.GetUserInfoListComplete:
            return {
                ...state,
                userInfoList: action.listItems,
                isLoading: false
            };

        // ユーザ情報更新
        case UserEvents.UpdateUserInfoStarted:
            return {
                ...state,
                isLoading: true,
                isUpdateUserInfo: true,
                isSuccessUpdateUserInfo: false,
                isFailedUpdateUserInfo: false
            };
        case UserEvents.UpdateUserInfoComplete:
            return {
                ...state,
                userInfoList: action.listItems,
                userInfo: {
                    ...state.userInfo,
                    imageUrl: refreshLoginUserImage(action.listItems, state.userInfo)
                },
                isLoading: false,
                isUpdateUserInfo: false,
                isSuccessUpdateUserInfo: true,
                isFailedUpdateUserInfo: false
            };
        case UserEvents.UpdateUserInfoFailed:
            return {
                ...state,
                isLoading: false,
                isUpdateUserInfo: false,
                isSuccessUpdateUserInfo: false,
                isFailedUpdateUserInfo: true
            };

        case UserEvents.LoginStarted:
            return {
                ...state,
                isLoading: false
            };
        case UserEvents.LoginComplete:
            return {
                ...state,
                user: action.user,
                userInfo: action.user,
                isLoading: false
            };

        case UserEvents.AuthComplete:
            return {
                ...state,
                email: action.email,
                isLoading: false
            };
        case UserEvents.UpdateUserProfileImageStarted:
            return {
                ...state,
                isLoading: false,
                isSuccessUpdateUserProfileImage: false,
                isFailedUpdateUserProfileImage: false,
            };
        case UserEvents.UpdateUserProfileImageComplete:
            return {
                ...state,
                userInfo: action.user,
                isLoading: false,
                isSuccessUpdateUserProfileImage: true,
                isFailedUpdateUserProfileImage: false,
            };
        case UserEvents.UpdateUserProfileImageFailed:
            return {
                ...state,
                isLoading: false,
                isSuccessUpdateUserProfileImage: false,
                isFailedUpdateUserProfileImage: true,
            };
        // ユーザスキル取得
        case UserEvents.GetSkillListStarted:
            return {
                ...state,
                isLoading: false
            };

        case UserEvents.GetSkillListComplete:
            return {
                ...state,
                skillList: action.outputSkillList,
                isLoading: false
            };
        // バッチの手動実行
        case UserEvents.StartSyncBatch:
            return {
                ...state,
                isLoading: true
            };
        case UserEvents.StartSyncBatchComplete:
            return {
                ...state,
                errorMessage: "",
                isLoading: false
            };
        case UserEvents.StartSyncBatchFailed:
            return {
                ...state,
                errorMessage: action.error,
                isLoading: false
            };

        case UserEvents.ValidateSSOTokenStarted:
            return {
                ...state,
                isAuthenticating: true
            };
        case UserEvents.ValidateSSOTokenSuccess:
            return {
                ...state,
                isAuthenticating: false,
                userInfo: action.user
            };

        case UserEvents.ValidateSSOTokenFailure:
            return {
                ...state,
                errorMessage: action.error,
                isAuthenticating: false
            };
        default:
            return state;
    }
}
